import { render, staticRenderFns } from "./userBasic.vue?vue&type=template&id=713263ce&scoped=true"
import script from "./userBasic.vue?vue&type=script&lang=js"
export * from "./userBasic.vue?vue&type=script&lang=js"
import style0 from "./userBasic.vue?vue&type=style&index=0&id=713263ce&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713263ce",
  null
  
)

export default component.exports